<template>
  <b-notification :closable="false" :class="$style.loadingContainer">
    <b-loading :is-full-page="false" :active="true"></b-loading>
  </b-notification>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BaseLoading extends Vue {}
</script>

<style lang="scss" module>
.loadingContainer {
  width: 100%;
  height: 200px;

  :global .loading-overlay {
    .loading-icon::after {
      border: 2px solid $secondary;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
}
</style>
